module.exports = __webpack_public_path__ + "media/images/top/pap/common/img_inquiry02-147bd201f4afaa560b95b1cde76fa670.png";